export const nodalEmail = 'hello@nodal.com';
